<template>
  <span class="d-inline-block" tabindex="0" v-b-tooltip="currentTooltip">
    <b-button
      :variant="variant"
      :disabled="disabled"
      @click="$emit('click')"
      :style="tooltip ? 'pointer-events: none;' : ''"
    >
      <i v-if="leadingIcon" :class="'bi bi-' + leadingIcon" />
      <b-spinner v-if="loading" small />
      <slot></slot>
      <i v-if="trailingIcon" :class="'bi bi-' + trailingIcon" />
    </b-button>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Button',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    variant: String,
    enabled: {
      type: Boolean,
      default: true,
    },
    leadingIcon: {
      type: String,
    },
    trailingIcon: {
      type: String,
    },
    type: String,
    tooltip: String,
    tooltipPosition: {
      type: String,
      default: 'top',
    },
  },
  computed: {
    disabled() {
      return this.loading || !this.enabled;
    },
    currentTooltip() {
      return {
        disabled: !this.tooltip,
        placement: this.tooltipPosition,
        title: this.tooltip,
      };
    },
  },
});
</script>
